import React from "react";
import Select from "../ui/Select";
import { ALL_GROUPS } from "../../domain/inconsistencies";
import { RULE_GROUP_META } from "../../domain/inconsistencyRules";

const OPTIONS = [{ value: ALL_GROUPS, label: "Todos os grupos" }].concat(
  Object.entries(RULE_GROUP_META).map(([group, meta]) => ({ value: group, label: meta.label }))
);

function RuleGroupFilter({ value, onChange }) {
  return (
    <Select label="Filtrar por grupo" value={value} options={OPTIONS} onChange={onChange} />
  );
}

export default RuleGroupFilter;
